<div class="modalHeader">
    <div class="row model-header">
      <div class="col-1">
        <img src="{{ image_url }}" height="45px" width="45px" />
      </div>
      <div class="col-9">
        <div class="editRowModal">
          <div class="modalHeader m-auto text-center clearfix">
            <div class="modal-about">
              <div class="fw-bold p-t-5 p-l-10 font-17">
                {{ TitleMessage | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 d-flex justify-content-end">
        <button type="button" aria-label="close" mat-mini-fab matTooltip="{{ 'COMMON.TOOL_TIP.BACK' | translate }}"
          color="warn" (click)="closeDialog()">
          <mat-icon class="col-white">close</mat-icon>
        </button>
      </div>
    </div>
  </div>
  
  
  <div class="m-5">
  <div class="modal-body">
    {{'Please provide this one time password (OTP) to the support team to help you out on SmartAccuPay. ' | translate}}
    <h1 class="text-center mt-3">{{ otp }}</h1>
  </div>
  
  <div class="example-button-row"  style="text-align: center;">
    <button mat-raised-button (click)="dialogRef.close()" color="warn" class="width-set-1 btn-width"
      tabindex="-1">{{'COMMON.ACTIONS.CANCEL' | translate}}</button>
  </div>
  </div>